// extracted by mini-css-extract-plugin
module.exports = {"spinner_container":"styles_spinner_container__3PaN3"};